<template>
    <el-container>
    <el-header style="background-color:white;margin-top: 5px;height: 40px;">
      <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
        <el-form-item label="用户昵称">
          <el-input v-model="formInline.name" placeholder="用户昵称" class="elInput"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="formInline.phone" placeholder="电话" class="elInput"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="formInline.email" placeholder="邮箱" class="elInput"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.type" class="elInput">
            <el-option label="全部" value=""></el-option>
            <el-option label="正常" value="0"></el-option>
            <el-option label="封停" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn" @click="onSubmit"><i class="el-icon-search"></i>查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" class="btn" @click="resetting"><i class="el-icon-refresh"></i>重置</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main class="elMain">
      <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
        <el-table-column align="center" label="ID" prop="id" width="160"></el-table-column>
        <el-table-column align="center" label="用户名" prop="username"></el-table-column>
        <el-table-column align="center" label="姓名" prop="name" width="180"></el-table-column>
        <el-table-column align="center" label="电话" prop="phone"></el-table-column>
        <el-table-column align="center" label="邮箱" prop="email"></el-table-column>
        <el-table-column align="center" label="性别" prop="sex" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.sex==='1'">男</span>
            <span v-if="scope.row.sex==='2'">女</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="type">
          <template slot-scope="scope">
            <span v-if="scope.row.type==='0'" style="color: green;">正常</span>
            <span v-if="scope.row.type==='1'" style="color: red;">封停</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="商户认证" prop="shop_type">
          <template slot-scope="scope">
            <span v-if="scope.row.shop_type==='0'" style="color: orange;">未认证</span>
            <span v-if="scope.row.shop_type==='1'" style="color: green;">已认证</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.type==='0'">
              <el-button size="small" @click="handleEdit(scope.$index, scope.row)">封停</el-button>
            </span>
            <span v-if="scope.row.type==='1'">
              <el-button size="small" @click="handleEdit(scope.$index, scope.row)">解封</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <div style="padding: 15px 0;text-align: right;">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
          :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
        </el-pagination>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  export default {
    data() {
      return {
        tableData:[],
        loading: false,
        formInline: {
          name: '',
          phone:'',
          email:'',
          type:'',
          pageNum:1,
          pageSize:10
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0
      }
    },
    created() {

    },
    //页面开启时执行
    mounted(){
      this.chark();
      this.getData();
    },
    methods: {
      //进行判定
      chark(){
        this.$emit("parentHandle", 3)
        //this.$parent.$parent.$parent.$parent.PDHTAdmin_types(3);
      },
      //
      handleEdit(index, row) {
        row.admin_id=this.$store.state.a_id;
        commonAPI('updateUserType',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        })
        //console.log(index, row);
      },
      getData() {
        this.loading = true,
          commonAPI('queryUserList',this.formInline).then(res => {
            this.loading = false;
            this.tableData = res.data.data.rows;
            this.pageTotal=res.data.data.total;
            //console.log(res.data.rows);
          })
      },
      onSubmit() {
        this.getData();
      },
      resetting() {
        this.formInline.name = '';
        this.formInline.phone = '';
        this.formInline.email = '';
        this.formInline.type = '';
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      }
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/users/userList.vue